import { ReactNode } from 'react'

import { ReportsTabs } from '../../model'

import s from './styles.module.scss'

export const Header = ({ tabsSelector, filters }: { tabsSelector?: ReactNode; filters?: ReactNode }) => {
  return (
    <div className={s.header}>
      <div className={s.left}>{tabsSelector}</div>
      <div className={s.right}>{filters}</div>
    </div>
  )
}
